export const getPageInfo = (routes: { [key: string]: any }, location: string) => {
  const page = Object.entries(routes).find(([name, path]) => path === location)

  return {
    page_title: page?.[0].toLowerCase() || location,
    page_location: location,
  }
}
